import { Outlet } from "react-router-dom";
import { Header } from "../general/Header";
import { Sidebar } from "../general/Sidebar";
import { RootUi } from "./RootUi";
import { Box } from "@chakra-ui/react";

export const InternalLayout = () => {

    return (
        <RootUi>
            <Header />
            <Body>
                <Outlet />
            </Body>
        </RootUi>
    )
}

const Body = ({ children }: any) => {

    return (
        <Box bg={'gray.50'} flex={1}>
            {children}
        </Box>
    )
}